import type { ChatItem } from './reducer';

const SUMMARY_MAX_LENGTH = 160;

const truncate = (value: string, max = SUMMARY_MAX_LENGTH) => {
  const oneLine = value.replace(/\s+/g, ' ').trim();
  return oneLine.length > max ? `${oneLine.slice(0, max)}…` : oneLine;
};

// e.g. ".../ws/src/blocks/x/a.js"
const WORKSPACE_PATH = /\S*\/ws\/(\S+)/g;

const isFillerLine = (line: string) => /^(-{3,}|`{3,}.*|\s*)$/.test(line);

export const shortenWorkspacePaths = (value: string) =>
  value.replace(WORKSPACE_PATH, '$1');

export const toolArgsLabel = (argsSummary: string | undefined): string => {
  const value = shortenWorkspacePaths((argsSummary ?? '').trim());
  if (!value.startsWith('/')) return value;
  return value.split('/').filter(Boolean).slice(-2).join('/');
};

export const toolPreview = (
  item: Pick<
    Extract<ChatItem, { kind: 'tool' }>,
    'status' | 'partial' | 'summary'
  >
): string => {
  const lines = (item.status === 'running' ? item.partial : item.summary)
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => !isFillerLine(line));
  const line = item.status === 'running' ? lines[lines.length - 1] : lines[0];
  return line ? truncate(shortenWorkspacePaths(line)) : '';
};
